import { helpers, required } from '@vuelidate/validators'
import type { PostalCodeCountry } from './usePostalCode.types'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

const POSTAL_CODE_REGEX = {
  PL: /^[0-9]{2}-[0-9]{3}$/,
  HR: /^[1-9][0-9]{4}$/,
  SK: /^[0-9]{3}\s[0-9]{2}$/,
  BG: /^[1-9][0-9]{3}$/,
  TR: /^[0-9]{5}$/,
}

export function usePostalCode(field: string, country: PostalCodeCountry, t: TInstance) {
  const postalCodeValidator = helpers.withMessage(
    () => t(`formValidatorMessages.postalCode.invalid.${country}`),
    (value: string) => {
      if (!value) return true
      const regex = POSTAL_CODE_REGEX[country]
      return regex ? regex.test(value) : true
    },
  )

  return ({
    [`${field}`]: {
      required: helpers.withMessage(
        () => t('formValidatorMessages.postalCode.required'),
        required,
      ),
      postalCodeValidator,
    },
  })
}
